// extracted by mini-css-extract-plugin
export var phone = "_2o-0";
export var phoneDragging = "_2o-1";